import React from "react";
import ReactDOM from "react-dom";

import App from './src/App.jsx';

var mountNode = document.getElementById("app");
ReactDOM.render(<App />, mountNode);
